<template>
 <div class="footer mt-4">
    <div class="footer-column">
       
        <div class="footer-column__item footer-column__item-flex">
            <div class="footer-category">
                <strong class="footer-category__title">Productos</strong>
                <a class="footer-category__anchor" :class="(productos)?'footer-category__anchor--active':''" @click="(productos)?productos=false:productos=true" role="button">
                    <span class="hidden">open</span></a>

                <div class="footer-category__list-wrap">
                    
                    <ul class="footer-category__list">
                        <li class="footer-category__item">
                           
                            <a class="footer-category__link" href="https://shop.samsung.cl/mobile/smartphones?map=c" target="_blank">Smartphones</a>
                        </li>
                        <li class="footer-category__item">
                           
                            <a class="footer-category__link" href="https://shop.samsung.cl/mobile/tablets?map=c,c&amp;O=OrderByReleaseDateDESC" target="_blank">Tablets</a>
                        </li>
                        <li class="footer-category__item">
                            
                            <a class="footer-category__link" href="https://shop.samsung.cl/mobile/wearables?map=c,c&amp;O=OrderByReleaseDateDESC" target="_blank">Wearables</a>
                        </li>
                        <li class="footer-category__item">
                            
                            <a class="footer-category__link" href="https://shop.samsung.cl/tv-y-audio?map=c" target="_blank">TV</a>
                        </li>
                        <li class="footer-category__item">
                            
                            <a class="footer-category__link" href="https://shop.samsung.cl/tv-y-audio/audio-y-video?map=c,c" target="_blank">Audio &amp;
                                Video</a>
                        </li>
                        <li class="footer-category__item">
                            
                            <a class="footer-category__link" href="https://shop.samsung.cl/linea-blanca?map=c&amp;O=OrderByPriceDESC" target="_blank">Línea
                                Blanca</a>
                        </li>
                    </ul>
                    <ul class="footer-category__list">
                        <li class="footer-category__item">
                           
                            <a class="footer-category__link" href="https://shop.samsung.cl/it/monitores?map=c,c" target="_blank">Monitores</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        
        <div class="footer-column__item">
            <div class="footer-category">
                <strong class="footer-category__title">Tiendas</strong>
                <a class="footer-category__anchor" :class="(tiendas)?'footer-category__anchor--active':''" @click="(tiendas)?tiendas=false:tiendas=true" role="button"><span
                        class="hidden">open</span></a>

                <div class="footer-category__list-wrap">
                    <ul class="footer-category__list">
                        <li class="footer-category__item">                            
                            <a class="footer-category__link s-ico-new-window" href="https://tienda.mercadolibre.cl/samsung" target="_blank">Tienda oficial Mercado Libre</a>
                        </li>
                        <li class="footer-category__item">                           
                            <a class="footer-category__link" href="https://shop.samsung.cl/tradein" target="_blank">Trade In </a>
                        </li>
                        <li class="footer-category__item">                            
                            <a class="footer-category__link" href="https://www.samsung.com/cl/apps/samsung-health/" target="_blank">Samsung Health</a>
                        </li>
                        <li class="footer-category__item">                            
                            <a class="footer-category__link" href="https://www.samsung.com/cl/apps/smartthings/" target="_blank">SmartThings</a>
                        </li>
                        <li class="footer-category__item">                            
                            <a class="footer-category__link" href="https://samsung-ayuda.zendesk.com/hc/es" target="_blank">Ayuda &amp;
                                Soporte - Preguntas frecuentes</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        
        <div class="footer-column__item">
            <div class="footer-category">
                <strong class="footer-category__title">Soporte</strong>
                <a class="footer-category__anchor" :class="(soporte)?'footer-category__anchor--active':''" @click="(soporte)?soporte=false:soporte=true" role="button" target="_blank"><span
                        class="hidden">open</span></a>
                <div class="footer-category__list-wrap">
                    <ul class="footer-category__list">
                        <li class="footer-category__item">                          
                            <a class="footer-category__link" href="https://shop.samsung.cl/institucional/atencion-al-cliente" target="_blank">Soporte Email</a>
                        </li>
                        <li class="footer-category__item">
                            
                            <a class="footer-category__link" href="https://shop.samsung.cl/institucional/atencion-al-cliente" target="_blank">Soporte
                                Telefónico</a>
                        </li>
                        <li class="footer-category__item">
                           
                            <a class="footer-category__link" href="https://www.samsung.com/cl/info/contactus/" target="_blank">Soporte
                                Técnico</a>
                        </li>
                        <li class="footer-category__item">
                           
                            <a class="footer-category__link" href="https://www.samsung.com/cl/support/" target="_blank">Garantía y
                                Servicio Técnico</a>
                        </li>
                        <li class="footer-category__item">
                            
                            <a class="footer-category__link" href="https://shop.samsung.cl/bases-legales" target="_blank">Bases legales promociones</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        
        <div class="footer-column__item">
            <div class="footer-category">
                <strong class="footer-category__title">Compañía</strong>
                <a class="footer-category__anchor" :class="(compania)?'footer-category__anchor--active':''" @click="(compania)?compania=false:compania=true" role="button"><span
                        class="hidden">open</span></a>

                <div class="footer-category__list-wrap">
                    <ul class="footer-category__list">
                        <li class="footer-category__item">                            
                            <a class="footer-category__link s-ico-new-window" href="https://www.samsung.com/cl/aboutsamsung/home/" target="_blank">Sobre nosotros</a>
                        </li>
                        <li class="footer-category__item">
                            
                            <a class="footer-category__link" href="https://shop.samsung.cl/clubsmart" target="_blank">Descuento Colaboradores - Ingresar</a>
                        </li>
                        <li class="footer-category__item">
                            
                            <a class="footer-category__link" href="https://shop.samsung.cl/quiero-ser-un-asociado" target="_blank">Quiero que mi empresa tenga
                                descuentos</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
  
    <div class="footer-bottom">
        <div class="footer-copyright-wrap">
           
            <div class="footer-copyright-align">
                <p class="footer-copyright">Copyright© 1995-<span class="getYearFooter">{{ dateFooter.getFullYear() }}</span> SAMSUNG Todos los derechos reservados.</p>
                <div class="footer-legal">Este Sitio Web se ve mejor con Internet Explorer 11 o superior, y / o versión más reciente de Google Chrome y Mozila Firefox.></div>
            </div>
        </div>
      
        <div class="footer-language-wrap">
           
            <div class="footer-sns">
                <span class="footer-sns__title">SÍGUENOS EN</span>
                <ul class="footer-sns__list">
                    <li class="footer-sns__item">
                        <a class="footer-sns__link" href="https://www.facebook.com/SamsungChile/?fref=ts" target="_blank" title="Open in a New Window">
                            <div class="image">
                                <svg xmlns="http://www.w3.org/2000/svg" width="96" height="96" viewBox="0 0 96 96">
                                    <path
                                        d="M92 48.267c0-24.3-19.699-44-44-44s-44 19.7-44 44C4 70.23 20.09 88.433 41.125 91.733V60.987H29.953v-12.72h11.172v-9.694c0-11.026 6.569-17.117 16.619-17.117 4.815 0 9.85.858 9.85.858v10.828h-5.549c-5.465 0-7.17 3.392-7.17 6.871v8.255h12.203l-1.951 12.718H54.875v30.747C75.91 88.433 92 70.228 92 48.267" />
                                </svg>
                            </div>

                        </a>
                    </li>
                    <li class="footer-sns__item">
                        <a class="footer-sns__link" href="https://twitter.com/SamsungChile" target="_blank" title="Open in a New Window">
                            <div class="image">
                                <svg xmlns="http://www.w3.org/2000/svg" width="96" height="96" viewBox="0 0 96 96">
                                    <path
                                        d="M31.304 84.563c33.964 0 52.537-28.13 52.537-52.524 0-.8-.016-1.595-.053-2.387 3.605-2.605 6.739-5.857 9.212-9.558-3.309 1.47-6.87 2.46-10.604 2.906 3.812-2.285 6.739-5.9 8.119-10.21-3.569 2.114-7.519 3.652-11.724 4.48-3.37-3.588-8.169-5.832-13.479-5.832-10.198 0-18.467 8.268-18.467 18.459 0 1.449.162 2.857.479 4.209-15.346-.773-28.954-8.119-38.06-19.288-1.588 2.728-2.501 5.897-2.501 9.278 0 6.405 3.26 12.058 8.217 15.366-3.029-.093-5.875-.925-8.363-2.309-.004.078-.004.154-.004.236 0 8.941 6.365 16.404 14.814 18.097-1.551.422-3.183.65-4.868.65-1.189 0-2.347-.117-3.471-.334 2.351 7.334 9.167 12.673 17.25 12.822-6.321 4.952-14.282 7.903-22.934 7.903-1.49 0-2.959-.085-4.404-.257 8.172 5.237 17.875 8.293 28.304 8.293" />
                                </svg>
                            </div>

                        </a>
                    </li>
                    <li class="footer-sns__item">
                        <a class="footer-sns__link" href="https://www.instagram.com/samsungchile/" target="_blank" title="Open in a New Window">
                            <div class="image">
                                <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
                                    <g>
                                        <g>
                                            <path d="M363.273,0H148.728C66.719,0,0,66.719,0,148.728v214.544C0,445.281,66.719,512,148.728,512h214.544
			C445.281,512,512,445.281,512,363.273V148.728C512,66.719,445.281,0,363.273,0z M472,363.272C472,423.225,423.225,472,363.273,472
			H148.728C88.775,472,40,423.225,40,363.273V148.728C40,88.775,88.775,40,148.728,40h214.544C423.225,40,472,88.775,472,148.728
			V363.272z" />
                                        </g>
                                    </g>
                                    <g>
                                        <g>
                                            <path d="M256,118c-76.094,0-138,61.906-138,138s61.906,138,138,138s138-61.906,138-138S332.094,118,256,118z M256,354
			c-54.037,0-98-43.963-98-98s43.963-98,98-98s98,43.963,98,98S310.037,354,256,354z" />
                                        </g>
                                    </g>
                                    <g>
                                        <g>
                                            <circle cx="396" cy="116" r="20" />
                                        </g>
                                    </g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                </svg>
                            </div>

                        </a>
                    </li>
                    <li class="footer-sns__item">
                        <a class="footer-sns__link" href="https://www.youtube.com/user/SamsungChile" target="_blank" title="Open in a New Window">
                            <div class="image">
                                <svg xmlns="http://www.w3.org/2000/svg" width="96" height="96" viewBox="0 0 96 96">
                                    <path
                                        d="M46.415 15.003h3.174c6.211.033 28.834.27 35.138 1.965 4.045 1.085 7.23 4.279 8.31 8.336 1.662 6.217 1.918 18.146 1.958 21.682l.003 1.712c-.028 3.084-.247 15.579-1.96 21.994-1.081 4.056-4.266 7.25-8.311 8.336-6.89 1.851-33.277 1.962-36.419 1.97l-3.137-.014c-7.542-.058-27.956-.36-33.894-1.956-4.044-1.085-7.23-4.28-8.311-8.336-1.849-6.921-1.957-20.917-1.964-22.54l.01-1.364c.046-3.763.323-15.378 1.954-21.484 1.08-4.057 4.267-7.251 8.31-8.336 6.305-1.695 28.928-1.932 35.139-1.965zm-8.262 18.66V62.33l25.28-14.332-25.28-14.334z" />
                                </svg>
                            </div>

                        </a>
                    </li>
                 
                    <li class="footer-sns__item">
                        <a class="footer-sns__link" href="mailto:contacto@samsung.cl" target="_blank" title="Open in a New Window">
                            <div class="image">
                                <svg xmlns="http://www.w3.org/2000/svg" width="96" height="96" viewBox="0 0 96 96">
                                    <path
                                        d="M91 12c1.866 0 3.395 1.466 3.495 3.308l.005.192v65c0 1.866-1.466 3.395-3.308 3.495L91 84H5c-1.866 0-3.395-1.466-3.495-3.308L1.5 80.5v-65c0-1.866 1.466-3.395 3.308-3.495L5 12h86zM80.206 26.573c-1.117-1.008-2.814-1.032-3.96-.054l-.146.133L48 53.81 19.936 26.689l-.146-.133c-1.145-.977-2.843-.953-3.958.054l-.142.137-.133.146c-.98 1.144-.955 2.843.052 3.96l.137.142 29.445 28.462.183.167c.685.588 1.532.906 2.391.955l.235.007.235-.007c.86-.049 1.707-.368 2.393-.956l.183-.167L80.29 30.957l.137-.142c1.008-1.117 1.032-2.815.054-3.959l-.133-.146-.142-.137z" />
                                </svg>
                            </div>

                        </a>
                    </li>
                </ul>
            </div>
           <div class="footer-language">
                <a class="footer-language__anchor" href="https://www.samsung.com/sec/function/ipredirection/ipredirectionLocalList1/" role="button">CHILE
                    /ESPAÑOL</a>
             
            </div>
           
            <div class="footer-terms">
                <ul class="footer-terms__list">
                    <li class="footer-terms__item">
                       
                        <a class="footer-terms__link" href="https://shop.samsung.cl/cl/accessibility/" target="_blank" title="Open in a New Window">Ayuda para accesibilidad</a>
                    </li>
                    <li class="footer-terms__item">
                      
                        <a class="footer-terms__link" href="https://shop.samsung.cl/arquivos/T%C3%A9rminos-y-Condiciones-Online-v-062019.pdf?v=636963809963300000">Términos
                            y condiciones</a>
                    </li>
                    <li class="footer-terms__item">
                       
                        <a class="footer-terms__link" href="https://shop.samsung.cl/Institucional/politica-de-privacidad-de-clubSmart">Politicas de privacidad</a>
                    </li>
                    <li class="footer-terms__item">
                       
                        <a class="footer-terms__link" href="https://www.samsung.com/cl/info/legal/">Aviso legal</a>
                    </li>
                    <li class="footer-terms__item">
                       
                        <a class="footer-terms__link" href="https://www.samsung.com/cl/info/sitemap/">Mapa del sitio</a>
                    </li>
                </ul>
            </div>
        </div>


</div>
</div>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return{
      dateFooter : new Date(),
      productos: false,
      tiendas: false,
      soporte: false,
      compania: false
    };
  },
  methods: {
    acordeon() {
      if (this.activo) {
        this.activo = false;
      } else {
        this.activo = true;
      }
    }
  }
};
</script>

<style scoped>
.hidden {
  display: none !important;
}
ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
}
.image,
.image__main,
.image__preview {
    display: inline-block;
    width: 100%;
}
svg {
    max-height: 100%;
    max-width: 100%;
}
  .footer .footer-back-to-top {
    height: 56px;
    margin: 0 auto;
    max-width: 1440px;
    background-color: #fff;
    border-bottom: 1px solid #ccc;
    text-align: right
}

.footer .footer-back-to-top__cta {
    display: inline-block;
    position: relative;
    padding: 18px 25px 19px;
    font-family: SamsungOne, arial, sans-serif;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.33;
    text-align: right;
    color: #000
}

.footer .footer-back-to-top__cta:after {
    display: inline-block;
    width: 16px;
    height: 16px;
    margin-left: 5px;
    transform: rotate(180deg);
    background: url('https://clubsmart.vteximg.com.br/arquivos/icon-regular-navigation-open-down.svg');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    vertical-align: middle;
    content: ""
}

@media only screen and (min-width: 769px) and (max-width:1440px) {
    .footer .footer-back-to-top {
        height: 3.88888889vw
    }
    .footer .footer-back-to-top__cta {
        padding: 1.25vw 1.73611111vw 1.31944444vw;
        font-size: .97222222vw
    }
    .footer .footer-back-to-top__cta:after {
        width: 1.11111111vw;
        height: 1.11111111vw;
        margin-left: .34722222vw
    }
}

@media only screen and (max-width: 701px) {
    .footer .footer-back-to-top {
        display: block;
        height: 13.88888889vw;
        border-bottom: none;
        text-align: center
    }
    .footer .footer-back-to-top:after {
        content: "";
        display: block;
        width: auto;
        height: 1px;
        background-color: #e7e7e7;
        margin: 0 24px
    }
    .footer .footer-back-to-top__cta {
        display: block;
        text-align: center;
        padding: 4.16666667vw 0 3.88888889vw;
        font-size: 3.88888889vw
    }
    .footer .footer-back-to-top__cta:after {
        width: 5vw;
        height: 5.83333333vw;
        margin-left: 3.55555556vw
    }
}

.footer .footer-bottom {
    position: relative;
    max-width: 1440px;
    margin: 0 auto;
    font-size: 0
}

.footer .footer-bottom .footer-copyright-wrap {
    position: relative;
    display: table;
    width: 100%;
    height: auto;
    border-bottom: 1px solid #d9d9d9
}

.footer .footer-bottom .footer-copyright-wrap .footer-copyright-align {
    display: table-cell;
    vertical-align: middle;
    padding: 17px 12px 15px 24px
}

.footer .footer-bottom .footer-copyright-wrap .footer-copyright-align .footer-copyright,
.footer .footer-bottom .footer-copyright-wrap .footer-copyright-align .footer-legal {
    display: block;
    max-width: 1023px;
    font-size: 12px;
    line-height: 1.33
}

.footer .footer-bottom .footer-copyright-wrap .footer-local-logo {
    display: table-cell;
    padding: 16px 24px 16px 12px;
    vertical-align: middle
}

.footer .footer-bottom .footer-copyright-wrap .footer-local-logo--wrap {
    display: -ms-flexbox;
    display: flex;
    -ms-flex-flow: row-reverse;
    flex-flow: row-reverse;
    -ms-flex-align: center;
    align-items: center;
    font-size: 0
}

.footer .footer-bottom .footer-copyright-wrap .footer-local-logo__item {
    max-width: 188px
}

.footer .footer-bottom .footer-copyright-wrap .footer-local-logo__item:after {
    content: "";
    display: block;
    clear: both;
    height: 0;
    visibility: hidden
}

.footer .footer-bottom .footer-copyright-wrap .footer-local-logo__item:nth-child(n+1) {
    margin-left: 24px
}

.footer .footer-bottom .footer-copyright-wrap .footer-local-logo__link {
    display: block
}

.footer .footer-bottom .footer-copyright-wrap .footer-local-logo .responsive-img {
    max-width: 100%
}

.footer .footer-bottom .footer-language-wrap {
    position: relative;
    height: 72px;
    padding-left: 24px
}

.footer .footer-bottom .footer-language-wrap .footer-sns {
    display: table;
    height: 100%;
    float: right;
    margin-right: 24px
}

.footer .footer-bottom .footer-language-wrap .footer-sns__title {
    display: table-cell;
    vertical-align: middle;
    height: 16px;
    font-family: SamsungOne, arial, sans-serif;
    font-size: 12px;
    line-height: 1.33
}

.footer .footer-bottom .footer-language-wrap .footer-sns__list {
    display: table-cell;
    vertical-align: middle
}

.footer .footer-bottom .footer-language-wrap .footer-sns__item {
    display: inline-block;
    border-radius: 100%;
    margin-left: 15px
}

.footer .footer-bottom .footer-language-wrap .footer-sns__link {
    display: block;
    width: 25px;
    height: 25px
}

.footer .footer-bottom .footer-language-wrap .footer-sns .responsive-img {
    max-width: 100%
}

.footer .footer-bottom .footer-language-wrap .footer-language {
    display: table;
    float: left;
    height: 72px;
    padding-right: 24px
}

.footer .footer-bottom .footer-language-wrap .footer-language:after {
    display: block;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 1px;
    height: 14px;
    margin-left: 24px;
    background-color: #d9d9d9;
    content: ""
}

.footer .footer-bottom .footer-language-wrap .footer-language__panel {
    display: none;
    position: absolute;
    left: -16px;
    bottom: 35px;
    z-index: 10
}

.footer .footer-bottom .footer-language-wrap .footer-language__anchor {
    display: table-cell;
    vertical-align: middle;
    font-weight: 700;
    font-size: 12px;
    line-height: 1.33;
    color: #000
}

.footer .footer-bottom .footer-language-wrap .footer-language__anchor:focus,
.footer .footer-bottom .footer-language-wrap .footer-language__anchor:hover {
    color: #218AFF
}

.footer .footer-bottom .footer-language-wrap .footer-language__anchor--active+.footer-language__panel {
    display: block
}

.footer .footer-bottom .footer-language-wrap .footer-language__dimmed {
    display: none
}

.footer .footer-bottom .footer-language-wrap .footer-language__content {
    position: relative;
    min-width: 286px;
    padding: 8px 0;
    right: -20px;
    bottom: 20px;
    border: 1px solid #d9d9d9;
    border-radius: 12px;
    background-color: #fff;
    font-size: 14px
}

.footer .footer-bottom .footer-language-wrap .footer-language__content:after {
    display: block;
    position: absolute;
    bottom: -7px;
    left: 64px;
    transform: rotate(45deg);
    width: 10px;
    height: 10px;
    border-color: #d9d9d9;
    border-style: solid;
    border-width: 0 1px 1px 0;
    background-color: #fff;
    content: ""
}

.footer .footer-bottom .footer-language-wrap .footer-language__link {
    display: block;
    position: relative;
    padding: 0 32px 0 16px;
    font-weight: 700;
    font-size: 14px;
    line-height: 32px;
    color: #000;
    text-transform: uppercase;
    word-break: break-all
}

.footer .footer-bottom .footer-language-wrap .footer-language__link:after {
  display: block;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 16px;
  width: 11px;
  height: 11px;
  background: url("https://clubsmart.vteximg.com.br/arquivos/icon__footer_language.svg")
    no-repeat;
  content: "";
}

.footer .footer-bottom .footer-language-wrap .footer-language__link:focus,
.footer .footer-bottom .footer-language-wrap .footer-language__link:hover {
    color: #218AFF
}

.footer .footer-bottom .footer-language-wrap .footer-language__link:focus:after,
.footer .footer-bottom .footer-language-wrap .footer-language__link:hover:after {
    background-image: url('https://clubsmart.vteximg.com.br/arquivos/icon_footer_language_active.svg')
}

.footer .footer-bottom .footer-language-wrap .footer-terms {
    display: table;
    max-width: 950px;
    height: 72px;
    padding: 0 0 0 13px
}

.footer .footer-bottom .footer-language-wrap .footer-terms__list {
    display: table-cell;
    vertical-align: middle;
    font-size: 0;
    text-align: left
}

.footer .footer-bottom .footer-language-wrap .footer-terms__item {
    display: inline-block
}

.footer .footer-bottom .footer-language-wrap .footer-terms__link {
    display: block;
    padding: 0 12px;
    font-size: 12px;
    line-height: 1.33;
    color: #000
}

@media only screen and (min-width: 769px) and (max-width:1440px) {
    .footer .footer-bottom .footer-copyright-wrap .footer-copyright-align {
        padding: 1.18055556vw .83333333vw 1.04166667vw 1.66666667vw
    }
    .footer .footer-bottom .footer-copyright-wrap .footer-copyright-align .footer-copyright,
    .footer .footer-bottom .footer-copyright-wrap .footer-copyright-align .footer-legal {
        max-width: 71.04166667vw;
        font-size: .83333333vw
    }
    .footer .footer-bottom .footer-copyright-wrap .footer-local-logo {
        max-width: 28.05555556vw;
        padding: 1.11111111vw 1.66666667vw 1.11111111vw .83333333vw
    }
    .footer .footer-bottom .footer-copyright-wrap .footer-local-logo__item {
        max-width: 13.05555556vw
    }
    .footer .footer-bottom .footer-copyright-wrap .footer-local-logo__item:nth-child(n+1) {
        margin-left: 1.66666667vw
    }
    .footer .footer-bottom .footer-language-wrap {
        height: 5vw;
        padding-left: 1.66666667vw
    }
    .footer .footer-bottom .footer-language-wrap .footer-sns {
        margin-right: 1.66666667vw
    }
    .footer .footer-bottom .footer-language-wrap .footer-sns__title {
        height: 1.11111111vw;
        font-size: .83333333vw
    }
    .footer .footer-bottom .footer-language-wrap .footer-sns__item {
        margin-left: 1.04166667vw
    }
    .footer .footer-bottom .footer-language-wrap .footer-sns__link {
        width: 1.73611111vw;
        height: 1.73611111vw
    }
    .footer .footer-bottom .footer-language-wrap .footer-language {
        height: 5vw;
        padding-right: 1.66666667vw
    }
    .footer .footer-bottom .footer-language-wrap .footer-language:after {
        height: .97222222vw;
        margin-left: 1.66666667vw
    }
    .footer .footer-bottom .footer-language-wrap .footer-language__anchor {
        font-size: .83333333vw
    }
    .footer .footer-bottom .footer-language-wrap .footer-language__panel {
        left: -1.11111111vw;
        bottom: 2.43055556vw
    }
    .footer .footer-bottom .footer-language-wrap .footer-language__content {
        min-width: 19.86111111vw;
        padding: .55555556vw 0;
        right: -1.38888889vw;
        bottom: 1.38888889vw;
        font-size: .97222222vw
    }
    .footer .footer-bottom .footer-language-wrap .footer-language__content:after {
        bottom: -.48611111vw;
        left: 4.44444444vw;
        width: .69444444vw;
        height: .69444444vw
    }
    .footer .footer-bottom .footer-language-wrap .footer-language__link {
        padding: 0 2.22222222vw 0 1.11111111vw;
        font-size: .83333333vw
    }
    .footer .footer-bottom .footer-language-wrap .footer-language__link:after {
        right: 1.11111111vw;
        width: .76388889vw;
        height: .76388889vw
    }
    .footer .footer-bottom .footer-language-wrap .footer-terms {
        height: 5vw;
        padding: 0 0 0 .90277778vw
    }
    .footer .footer-bottom .footer-language-wrap .footer-terms__link {
        padding: 0 .97222222vw;
        font-size: .83333333vw
    }
}

@media only screen and (max-width: 701px) {
    .footer .footer-bottom {
        padding: 9.72222222vw 6.66666667vw 6.11111111vw
    }
    .footer .footer-bottom .footer-copyright-wrap {
        display: block;
        border-bottom: none
    }
    .footer .footer-bottom .footer-copyright-wrap:after {
        display: none
    }
    .footer .footer-bottom .footer-copyright-wrap .footer-copyright-align {
        min-height: auto;
        padding: 0 0 8.88888889vw
    }
    .footer .footer-bottom .footer-copyright-wrap .footer-copyright-align .footer-copyright,
    .footer .footer-bottom .footer-copyright-wrap .footer-copyright-align .footer-legal {
        font-size: 3.33333333vw
    }
    .footer .footer-bottom .footer-copyright-wrap .footer-local-logo {
        display: block;
        float: right;
        width: 68.89%;
        padding: 0 0 4.44444444vw
    }
    .footer .footer-bottom .footer-copyright-wrap .footer-local-logo--wrap {
        display: inherit;
        -ms-flex-flow: inherit;
        flex-flow: inherit;
        -ms-flex-align: inherit;
        align-items: inherit;
        font-size: inherit
    }
    .footer .footer-bottom .footer-copyright-wrap .footer-local-logo__item {
        display: -ms-inline-flexbox;
        display: inline-flex;
        float: right;
        text-align: right;
        margin-bottom: 3.33333333vw;
        max-width: 52.22222222vw
    }
    .footer .footer-bottom .footer-copyright-wrap .footer-local-logo__item:nth-child(n+1) {
        margin-left: 6.66666667vw
    }
    .footer .footer-bottom .footer-copyright-wrap .footer-local-logo__item:last-of-type {
        margin-bottom: 0
    }
    .footer .footer-bottom .footer-language-wrap {
        display: inline-table;
        height: auto;
        padding-left: 0;
        width: 100%
    }
    .footer .footer-bottom .footer-language-wrap .footer-sns {
        display: block;
        width: 100%;
        text-align: center;
        margin-right: 0;
        margin-left: -1.11111111vw
    }
    .footer .footer-bottom .footer-language-wrap .footer-sns__title {
        display: block;
        width: 100%;
        height: auto;
        text-align: center;
        font-size: 3.33333333vw;
        padding: 2.22222222vw 0;
        line-height: 1.37
    }
    .footer .footer-bottom .footer-language-wrap .footer-sns__list {
        display: table;
        margin: 0 auto
    }
    .footer .footer-bottom .footer-language-wrap .footer-sns__item {
        display: table-cell;
        margin-left: 0
    }
    .footer .footer-bottom .footer-language-wrap .footer-sns__link {
        margin: 2.22222222vw;
        width: 6.66666667vw;
        height: 6.66666667vw
    }
    .footer .footer-bottom .footer-language-wrap .footer-language {
        position: absolute;
        display: inline-block;
        height: auto;
        padding-right: 0
    }
    .footer .footer-bottom .footer-language-wrap .footer-language:after {
        display: none
    }
    .footer .footer-bottom .footer-language-wrap .footer-language__anchor {
        display: inline-block;
        position: relative;
        padding-right: 3.88888889vw;
        font-size: 3.33333333vw
    }
    .footer .footer-bottom .footer-language-wrap .footer-language__anchor:after {
        display: block;
        position: absolute;
        top: 50%;
        right: 0;
        transform: translateY(-50%);
        width: 3.05555556vw;
        height: 3.05555556vw;
        background: url('https://clubsmart.vteximg.com.br/arquivos/icon_footer_language.svg') no-repeat;
        content: ""
    }
    .footer .footer-bottom .footer-language-wrap .footer-language__anchor:focus:after,
    .footer .footer-bottom .footer-language-wrap .footer-language__anchor:hover:after {
        background-image: url('https://clubsmart.vteximg.com.br/arquivos/icon_footer_language_active.svg')
    }
    .footer .footer-bottom .footer-language-wrap .footer-language__panel {
        position: fixed;
        width: 100%;
        padding: 0 6.66666667vw;
        left: 0;
        bottom: 0
    }
    .footer .footer-bottom .footer-language-wrap .footer-language__dimmed {
        display: block;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 10;
        width: 100%;
        height: 100%;
        background-color: #000;
        opacity: .85
    }
    .footer .footer-bottom .footer-language-wrap .footer-language__content {
        position: relative;
        right: 0;
        font-size: 3.33333333vw;
        bottom: 17.77777778vw;
        z-index: 11
    }
    .footer .footer-bottom .footer-language-wrap .footer-language__content:after {
        display: none
    }
    .footer .footer-bottom .footer-language-wrap .footer-terms {
        padding: 0;
        border-bottom: none;
        height: auto;
        width: 100%
    }
    .footer .footer-bottom .footer-language-wrap .footer-terms__list {
        text-align: center
    }
    .footer .footer-bottom .footer-language-wrap .footer-terms__link {
        font-size: 3.33333333vw;
        padding: 2.22222222vw 3.33333333vw;
        line-height: 1.37
    }
}

.footer .footer-column {
    display: table;
    width: 100%;
    max-width: 1440px;
    margin: 0 auto;
    border-top: 1px solid #ccc
}

.footer .footer-column__item {
    display: table-cell;
    padding-bottom: 24px;
    border-bottom: 1px solid #ccc;
    width: 25%
}

.footer .footer-column__item:nth-child(n+2) {
    border-left: 1px solid #d9d9d9
}

.footer .footer-column__item-flex~.footer-column__item {
    width: 20%
}

.footer .footer-column__item-flex {
    width: 40%
}

.footer .footer-column__item-flex .footer-category__list {
    width: 50%
}

.footer .footer-column__item-flex .footer-category__list+.footer-category__list {
    position: absolute;
    top: 56px;
    left: 50%
}

.footer .footer-column__item .footer-category {
    position: relative
}

.footer .footer-column__item .footer-category__title {
    display: block;
    height: 56px;
    padding: 16px 24px;
    font-size: 18px;
    line-height: 1.33;
    font-weight: 700
}

.footer .footer-column__item .footer-category__anchor {
    display: none
}

.footer .footer-column__item .footer-category__link {
    display: block;
    padding: 7px 24px;
    font-size: 14px;
    line-height: 1.33;
    color: #000
}

.footer .footer-column__item .footer-category__link:focus,
.footer .footer-column__item .footer-category__link:hover {
    color: #218AFF
}

.footer .footer-column__item .footer-category__link.new-window[target=_blank]:after {
    content: "";
    display: inline-block;
    background-image: url('https://clubsmart.vteximg.com.br/arquivos/icon-new-window-black.svg');
    background-repeat: no-repeat;
    background-size: 100% auto;
    vertical-align: middle
}

.footer .footer-column__item .footer-category__link.new-window[target=_blank]:active:after,
.footer .footer-column__item .footer-category__link.new-window[target=_blank]:focus:after,
.footer .footer-column__item .footer-category__link.new-window[target=_blank]:hover:after {
    background-image: url('https://clubsmart.vteximg.com.br/arquivos/icon-new-window-navy.svg')
}

.footer .footer-column__item .footer-category__link.new-window[target=_blank]:after {
    width: 14px;
    height: 14px;
    margin-left: 5px
}

@media only screen and (min-width: 769px) and (max-width:1440px) {
    .footer .footer-column__item {
        padding-bottom: 1.66666667vw
    }
    .footer .footer-column__item-flex .footer-category__list {
        height: 17.77777778vw
    }
    .footer .footer-column__item-flex .footer-category__list+.footer-category__list {
        top: 3.88888889vw
    }
    .footer .footer-column__item-flex .footer-category__item {
        height: 2.22222222vw
    }
    .footer .footer-column__item .footer-category__title {
        height: 3.88888889vw;
        padding: 1.11111111vw 1.66666667vw;
        font-size: 1.25vw
    }
    .footer .footer-column__item .footer-category__link {
        padding: .48611111vw 1.66666667vw;
        font-size: .97222222vw
    }
    .footer .footer-column__item .footer-category__link.new-window[target=_blank]:after {
        width: .97222222vw;
        height: .97222222vw;
        margin-left: .34722222vw
    }
}

@media only screen and (max-width: 701px) {
    .footer .footer-column {
        table-layout: auto
    }
    .footer .footer-column__item {
        display: block;
        position: relative;
        border: none;
        padding-bottom: 0
    }
    .footer .footer-column__item:after {
        content: "";
        display: block;
        width: auto;
        height: 1px;
        background-color: #e7e7e7;
        margin: 0 24px
    }
    .footer .footer-column__item:nth-child(n+2) {
        border-left-width: 0
    }
    .footer .footer-column__item>.footer-category__list {
        padding-bottom: 2.77777778vw
    }
    .footer .footer-column__item .footer-category__list-wrap {
        display: none;
        overflow: hidden
    }
    .footer .footer-column__item-flex,
    .footer .footer-column__item-flex~.footer-column__item {
        width: 100%
    }
    .footer .footer-column__item-flex .footer-category__list {
        width: 100%;
        height: auto
    }
    .footer .footer-column__item-flex .footer-category__list+.footer-category__list {
        position: static
    }
    .footer .footer-column__item-flex .footer-category__item {
        display: block;
        width: 100%;
        height: auto
    }
    .footer .footer-column .footer-category__title {
        height: 15.55555556vw;
        padding: 4.72222222vw 6.66666667vw;
        font-size: 4.44444444vw
    }
    .footer .footer-column .footer-category__anchor {
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 15.55555556vw
    }
    .footer .footer-column .footer-category__anchor+.footer-category__list-wrap {
        display: none
    }
    .footer .footer-column .footer-category__anchor:after {
        display: block;
        position: absolute;
        top: 50%;
        right: 6.38888889vw;
        width: 7.5vw;
        height: 7.5vw;
        transform: translateY(-50%);
        background: url('https://clubsmart.vteximg.com.br/arquivos/icon-regular-navigation-open-down.svg') no-repeat 50%;
        background-size: 100%;
        content: ""
    }
    .footer .footer-column .footer-category__anchor--active:after {
        transform: rotate(180deg);
        background: url('https://clubsmart.vteximg.com.br/arquivos/icon-regular-navigation-open-down.svg') no-repeat 50%;
        background-size: 100%
    }
    .footer .footer-column .footer-category__anchor--active+.footer-category__list,
    .footer .footer-column .footer-category__anchor--active+.footer-category__list+.footer-category__list {
        height: auto
    }
    .footer .footer-column .footer-category__anchor--active+.footer-category__list-wrap {
        display: block
    }
    .footer .footer-column .footer-category__anchor--active+.footer-category__list:after {
        content: "";
        position: absolute;
        bottom: 0;
        width: 100%;
        height: 1px;
        background-color: #fff
    }
    .footer .footer-column .footer-category__link {
        height: 11.11111111vw;
        padding: 3.05555556vw 8.61111111vw;
        font-size: 3.88888889vw;
        line-height: 1.36
    }
    .footer .footer-column .footer-category__link.new-window[target=_blank]:after {
        width: 3.88888889vw;
        height: 3.88888889vw;
        margin-left: 1.38888889vw
    }
}
</style>
